(function () {
  function updateFreeShipping(cart) {
    var container = document.querySelector('.fosie-free-shipping');
    if (!container || !cart) return;

    var goal = parseInt(container.dataset.freeShippingGoal, 10);
    var text = container.querySelector('[data-free-shipping-text]');
    var progress = container.querySelector('[data-free-shipping-progress]');
    var subtotal = cart.total_price || 0;

    if (!goal || !text || !progress) return;

    var percent = Math.min((subtotal / goal) * 100, 100);

    progress.style.width = percent + '%';

    if (subtotal >= goal) {
      text.textContent = '送料無料になりました！';
    } else {
      var remaining = goal - subtotal;
      var remainingYen = Math.ceil(remaining / 100);

      text.textContent =
        'あと ¥' + remainingYen.toLocaleString('ja-JP') + ' で送料無料';
    }
  }

  function getCart() {
    fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateFreeShipping(cart);
      })
      .catch(function () {});
  }

  // 商品を新しくカートへ追加したとき
  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(getCart, 150);
  });

  // カート内で数量を変更したとき
  document.addEventListener('cart:updated', function () {
    getCart();
  });

  // ページを最初に表示したとき
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', getCart);
  } else {
    getCart();
  }
})();